// extracted by mini-css-extract-plugin
export var footer = "_p3-5";
export var fulfillmentInput = "_p3-0";
export var shipDateInput = "_p3-1";
export var shipmentModal = "_p3-2";
export var shipmentModalContent = "_p3-3";
export var tableContainer = "_p3-4";